import { BaseCustomError, ErrorCode } from './base';

type BookingErrorCodes = ErrorCode.BookingSlotNotAvailable | ErrorCode.NotAllowedToMakeBooking;

export class BookingError extends BaseCustomError {
  public static notAllowed(message: string): BookingError {
    return new BookingError(ErrorCode.NotAllowedToMakeBooking, message);
  }

  public static slotNotAvailable(message: string): BookingError {
    return new BookingError(ErrorCode.BookingSlotNotAvailable, message);
  }

  constructor(
    errorCode: BookingErrorCodes,
    message: string,
    httpErrorCode: number = 400,
    data: any = {},
  ) {
    super(
      httpErrorCode,
      message,
      data,
      errorCode,
    );
  }
}
